// KMZ-eksport: pakker KML (+ evt. vedlegg som ikoner/overlays) til ett KMZ —
// en ZIP med `doc.kml` i rota, som ATAK/WinTAK/Google Earth åpner direkte.
// Egen minimal «store»-ZIP-skriver (ingen komprimering, ingen avhengigheter) med
// korrekt CRC-32, lokal header, sentralkatalog og EOCD. Ren + testbar (byte-nivå).
/** CRC-32 (IEEE 802.3) tabell — bygges én gang. */
const CRC_TABLE = (() => {
    const t = new Array(256);
    for (let n = 0; n < 256; n++) {
        let c = n;
        for (let k = 0; k < 8; k++)
            c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        t[n] = c >>> 0;
    }
    return t;
})();
export function crc32(bytes) {
    let c = 0xffffffff;
    for (let i = 0; i < bytes.length; i++)
        c = CRC_TABLE[(c ^ bytes[i]) & 0xff] ^ (c >>> 8);
    return (c ^ 0xffffffff) >>> 0;
}
function strBytes(s) { return new TextEncoder().encode(s); }
/**
 * Bygg en «store»-metode ZIP (ingen komprimering) av flere filer.
 * Returnerer hele arkivet som Uint8Array.
 */
export function buildZip(entries) {
    const chunks = [];
    const central = [];
    let offset = 0;
    const u16 = (v) => new Uint8Array([v & 0xff, (v >>> 8) & 0xff]);
    const u32 = (v) => new Uint8Array([v & 0xff, (v >>> 8) & 0xff, (v >>> 16) & 0xff, (v >>> 24) & 0xff]);
    const cat = (...parts) => {
        const len = parts.reduce((a, p) => a + p.length, 0);
        const out = new Uint8Array(len);
        let o = 0;
        for (const p of parts) {
            out.set(p, o);
            o += p.length;
        }
        return out;
    };
    for (const e of entries) {
        const nameB = strBytes(e.name);
        const crc = crc32(e.data);
        const size = e.data.length;
        // Lokal fil-header + data.
        const local = cat(u32(0x04034b50), u16(20), u16(0), u16(0), // sig, version, flags, method(store)
        u16(0), u16(0), // modtime, moddate (0)
        u32(crc), u32(size), u32(size), // crc, comp size, uncomp size
        u16(nameB.length), u16(0), // name len, extra len
        nameB, e.data);
        chunks.push(local);
        // Sentralkatalog-post.
        central.push(cat(u32(0x02014b50), u16(20), u16(20), u16(0), u16(0), // sig, made-by, needed, flags, method
        u16(0), u16(0), // modtime, moddate
        u32(crc), u32(size), u32(size), u16(nameB.length), u16(0), u16(0), // name, extra, comment len
        u16(0), u16(0), u32(0), // disk#, internal attrs, external attrs
        u32(offset), // relativ offset til lokal header
        nameB));
        offset += local.length;
    }
    const centralAll = central.reduce((acc, c) => {
        const out = new Uint8Array(acc.length + c.length);
        out.set(acc, 0);
        out.set(c, acc.length);
        return out;
    }, new Uint8Array(0));
    const eocd = cat(u32(0x06054b50), u16(0), u16(0), // sig, disk#, disk-with-CD
    u16(entries.length), u16(entries.length), // entries on disk, total entries
    u32(centralAll.length), u32(offset), // CD size, CD offset
    u16(0));
    const bodyLen = chunks.reduce((a, c) => a + c.length, 0);
    const total = new Uint8Array(bodyLen + centralAll.length + eocd.length);
    let o = 0;
    for (const c of chunks) {
        total.set(c, o);
        o += c.length;
    }
    total.set(centralAll, o);
    o += centralAll.length;
    total.set(eocd, o);
    return total;
}
/**
 * Bygg et KMZ fra KML-tekst (+ valgfrie vedlegg). `doc.kml` legges alltid i rota
 * (KMZ-konvensjon: første/roten-KML lastes automatisk).
 */
export function toKMZ(kml, attachments = []) {
    return buildZip([{ name: 'doc.kml', data: strBytes(kml) }, ...attachments]);
}
//# sourceMappingURL=kmz.js.map